(function(){
    'use strict'; 
    angular.module('app').controller('ThirdPartyAccountingApp', ThirdPartyAccountingApp); 
    ThirdPartyAccountingApp.$inject = [
        'ThirdPartyAccountingAppsTable'
    ]; 

    function ThirdPartyAccountingApp(
        ThirdPartyAccountingAppsTable
    ){
        const vm = this;
        
        init();
        function init(){
            initializeTableData();
        }

        function initializeTableData(){
            vm.thirdPartyAccountingAppsTableData = new ThirdPartyAccountingAppsTable().tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/api-access/ThirdPartyAccountingApp.js